// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimpleDateSelect_wrapper__4CVYa","month":"SimpleDateSelect_month__28sFk","day":"SimpleDateSelect_day__W64o8","year":"SimpleDateSelect_year__2rvm_"};